/**
 * Commercial service-order PDF fields on project_summary.
 * Uploads / new-service create write `service_order`; legacy WP used
 * `countersigned_service_order`; "executed" is a separate later-stage upload.
 */
export const COMMERCIAL_SERVICE_ORDER_FIELD_KEYS = [
  "service_order",
  "executed_service_order",
  "countersigned_service_order",
];

/**
 * Prefer the primary upload field, then executed / legacy countersigned.
 * @param {object|null|undefined} summary project_summary slice
 * @param {(value: unknown) => string} [hasFile] returns non-empty URL when a file is present
 * @returns {{ key: string, value: unknown } | null}
 */
export function resolveCommercialServiceOrderField(summary, hasFile) {
  if (!summary || typeof summary !== "object") return null;
  const check =
    typeof hasFile === "function"
      ? hasFile
      : (v) => {
          if (v == null || v === "" || v === false) return "";
          if (typeof v === "string") return v.trim();
          if (typeof v === "object") {
            if (typeof v.url === "string" && v.url.trim()) return v.url.trim();
          }
          return v ? "1" : "";
        };
  for (const key of COMMERCIAL_SERVICE_ORDER_FIELD_KEYS) {
    if (check(summary[key])) return { key, value: summary[key] };
  }
  return null;
}

/** Raw stored value for grid cells (object or URL string), or "". */
export function commercialServiceOrderStoredValue(summary) {
  return resolveCommercialServiceOrderField(summary)?.value ?? "";
}

export function commercialServiceOrderLabel(fieldKey) {
  if (fieldKey === "executed_service_order") return "Executed service order";
  if (fieldKey === "countersigned_service_order") return "Service order";
  return "Service order";
}
